/**
 * Encodes a URI using either encodeURIComponent or encodeURI.
 * @param type - The encoding function to use. Either 'encodeURIComponent' or 'encodeURI'.
 * @param uri - The URI to encode.
 * @returns The encoded URI.
 * @example
 * encodeUriWith('encodeURI', 'http://...')
 */
export const encodeUriWith = (
  type: 'encodeURIComponent' | 'encodeURI',
  uri: string | boolean | number
): string => {
  if (type === 'encodeURIComponent') {
    return encodeURIComponent(uri as string)
  }

  if (typeof uri === 'string' && decodeURI(uri) === uri) {
    return encodeURI(uri)
  }

  return encodeUriWith('encodeURI', decodeURI(uri.toString()))
}
